import { Component, OnInit, Input } from '@angular/core';
import { Teacher } from 'src/app/domain/ot-event';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-teacher-profile',
  templateUrl: './teacher-profile.component.html',
  styleUrls: ['./teacher-profile.component.scss']
})
export class TeacherProfileComponent implements OnInit {

  @Input()
  public teacher: Teacher;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  public getProfilePictureWidth(teacher: Teacher): string {
    if (! teacher.profilePictureWidth || ! teacher.profilePictureHeight) {
      return 'auto';
    }
    if (teacher.profilePictureWidth > teacher.profilePictureHeight) {
      return '200px';
    }
    return (teacher.profilePictureWidth / teacher.profilePictureHeight * 200) + 'px';
  }

  public getProfilePictureHeight(teacher: Teacher): string {
    if (! teacher.profilePictureWidth || ! teacher.profilePictureHeight) {
      return 'auto';
    }
    if (teacher.profilePictureHeight > teacher.profilePictureWidth) {
      return '200px';
    }
    return (teacher.profilePictureHeight / teacher.profilePictureWidth * 200) + 'px';
  }
}
